import { useMarketplaceApi } from '@/context/marketplace.context';
import {
    buildBrandsCsvDownloadQuery,
    buildProductsCsvDownloadQuery,
    buildReviewsCsvDownloadQuery,
} from '@/components/action-buttons/csv-export-action.queries';
import {
    CsvExportActionResult,
    ProductsCsvExportActionResult,
    UseProductsCsvExportActionArgs,
    UseReviewsCsvExportActionArgs,
} from '@/components/action-buttons/csv-export-action.types';
import { useSelectionScopedMarketplaceCsvExportAction } from '@/components/action-buttons/use-selection-scoped-marketplace-csv-export-action';

export const useReviewsCsvExportAction = ({
    accessToken,
    filtersQuery,
    sort,
    selectionSessionId,
    pickedReviews,
    ...lifecycle
}: UseReviewsCsvExportActionArgs): CsvExportActionResult => {
    const { reviewsApi } = useMarketplaceApi();

    return useSelectionScopedMarketplaceCsvExportAction({
        accessToken,
        pickedIds: pickedReviews,
        selectionSessionId,
        ...lifecycle,
        runSelectionScopedCsvDownload: ({ accessToken, exportOperationId, signal, selectionScope }) =>
            reviewsApi.downloadCsv(
                buildReviewsCsvDownloadQuery({
                    filtersQuery,
                    sort,
                    selectionScope,
                    exportOperationId,
                }),
                { authToken: accessToken, signal },
            ),
    });
};

export const useProductsCsvExportAction = ({
    accessToken,
    activeTable,
    selectionSessionId,
    pickedProducts,
    pickedBrandGroups,
    ...lifecycle
}: UseProductsCsvExportActionArgs): ProductsCsvExportActionResult => {
    const { productsApi, brandsApi } = useMarketplaceApi();
    const { exportCsv: exportProductsCsv, cancelExport } = useSelectionScopedMarketplaceCsvExportAction({
        accessToken,
        pickedIds: pickedProducts,
        selectionSessionId,
        ...lifecycle,
        runSelectionScopedCsvDownload: ({ accessToken, exportOperationId, signal, selectionScope }) =>
            activeTable === 'brands'
                ? brandsApi.downloadCsv(
                      buildBrandsCsvDownloadQuery({
                          pickedBrandGroups,
                          exportOperationId,
                      }),
                      { authToken: accessToken, signal },
                  )
                : productsApi.downloadCsv(
                      buildProductsCsvDownloadQuery({
                          selectionScope,
                          exportOperationId,
                      }),
                      { authToken: accessToken, signal },
                  ),
    });

    return {
        exportProductsCsv,
        cancelExport,
    };
};
